import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AvgTimeSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AvgTimeSVG;
